import { create } from "zustand";

interface HotelMetadata {
  name: string;
  hotelLogoUrl: string;
  guestBookingHeroImageSummerBlobFilePath: string;
}

interface UserMarketingProfile {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  emailMarketingOptIn?: boolean;
  smsMarketingOptIn?: boolean;
}

interface OfferMetadata {
  headlineText: string;
  descriptionText: string;
  hotel: HotelMetadata;
  discountPercentage: number;
  expiresAt: string;
  metadata?: {
    offerCode: string;
  };
  user?: {
    firstName?: string;
  };
  isExpired?: boolean;
  userMarketingProfile?: UserMarketingProfile;
}

interface MetadataStore {
  offerMetadata: OfferMetadata | null;
  setOfferMetadata: (metadata: OfferMetadata) => void;
}

const useMetadataStore = create<MetadataStore>((set) => ({
  offerMetadata: null,
  setOfferMetadata: (metadata) => {
    set({ offerMetadata: metadata });
  },
}));

export default useMetadataStore;
